// @flow
import * as React from 'react';
import styled from 'styled-components';
import Icon from 'components/Icon';
import { BorderlessButton } from 'components/Button';
import Text from 'components/Text';
import { colors } from '../theme';

const StyledBorderlessButton = styled(BorderlessButton)`
  display: flex;
  align-items: center;
  padding: 0;
  padding-right: 5px;
  &:hover {
    color: ${colors.battleshipGrey};
  }
`;

const StyledIcon = styled(Icon)`
  ${/* sc-selector */ StyledBorderlessButton}:hover & {
    &:not(:disabled) {
      color: ${colors.turtleGreen};
    }
  }
`;

const DeleteButton = ({ children, ...props }: { children?: React.Node }) => (
  <StyledBorderlessButton size="small" {...props}>
    <StyledIcon
      width={12}
      height={13.34}
      name="trashcan"
      fill={colors.greyishBrown}
    />
    <Text as="span" pl="5px">
      {children}
    </Text>
  </StyledBorderlessButton>
);

export default DeleteButton;
